import React from 'react';

import useUser from 'src/hooks/use-user';
import useDutchiePayEnrollment from 'src/hooks/use-dutchiePay-enrollment';
import useInstoreCart from 'src/hooks/use-instore-cart';

import useErnie from 'shared/hooks/use-ernie';
import { ERNIE_TYPES } from 'shared/constants';

import { CartViews } from 'src/payments/state/instore-cart';
import { ChildrenContainer } from 'src/payments/layout/common/children-container';
import { CompleteAccountForm } from 'src/payments/components/complete-account-form';

export const CompleteAccount = (): JSX.Element => {
  const showErnie = useErnie();
  const User = useUser();
  const DutchiePayEnrollment = useDutchiePayEnrollment();
  const InstoreCart = useInstoreCart();

  const onSuccess = (): void => {
    User.refetch();
    showErnie('Account updated successfully.', ERNIE_TYPES.SUCCESS);
    DutchiePayEnrollment.signUpStepCompleted();
    InstoreCart.setCurrentView(CartViews.BARCODE);
  };

  return (
    <ChildrenContainer cardView>
      <CompleteAccountForm onSuccess={onSuccess} />
    </ChildrenContainer>
  );
};
